import { render, staticRenderFns } from "./Treat.vue?vue&type=template&id=2399aa38&"
import script from "./Treat.vue?vue&type=script&lang=js&"
export * from "./Treat.vue?vue&type=script&lang=js&"
import style0 from "./Treat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports